import React from 'react';
import { Autocomplete, TextField, Chip } from '@mui/material';
import { IoMdArrowDropdown } from 'react-icons/io';
import { IoClose } from 'react-icons/io5';

export const ComboBox = ({
  handleAutoboxFilterChange,
  handleFilterChange,
  selectField,
  filters
}) => {
  const handleAutocompleteChange = (event, newValue) => {
    if (!newValue) {
      handleAutoboxFilterChange(selectField.name, { value: '', label: '' });
      return;
    }

    if (typeof newValue === 'string') {
      handleAutoboxFilterChange(selectField.name, { value: newValue, label: newValue });
    } else {
      handleAutoboxFilterChange(selectField.name, newValue);
    }
  };

  const selectedValue = selectField?.options?.find(
    (option) => option.value === filters[selectField.name]
  );

  return (
    <Autocomplete
      size="small"
      options={selectField.options}
      freeSolo
      value={selectedValue || null}
      getOptionLabel={(option) => option?.label || ''}
      onChange={handleAutocompleteChange}
      onInputChange={(event, newInputValue) => {
        handleFilterChange(event, newInputValue);
      }}
      renderTags={(tagValue, getTagProps) => (
        <Chip
          label={tagValue.label}
          size="small"
          onDelete={() => handleAutocompleteChange(null, null)}
          sx={{
            backgroundColor: '#E5E7EB',
            '& .MuiChip-label': {
              color: '#1F1B45',
            },
            '& .MuiChip-deleteIcon': {
              color: '#666',
              '&:hover': {
                color: '#1F1B45',
              },
            },
          }}
        />
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label={selectField.label}
          variant="outlined"
          name={selectField.name}
          sx={{
            '& .MuiOutlinedInput-root': {
              height: selectedValue ? '48px' : '40px',
              transition: 'height 0.2s ease',
              backgroundColor: '#fff',
              borderRadius: '10px',
              '& fieldset': {
                borderColor: '#BBDEFB',
              },
              '&:hover fieldset': {
                borderColor: '#1565C0',
              },
              '&.Mui-focused fieldset': {
                borderColor: '#1565C0',
              }
            },
            '& .MuiInputLabel-root': {
              transform: 'translate(14px, -9px) scale(0.75)',
              '&[data-shrink="false"]': {
                transform: 'translate(14px, 8px) scale(1)',
              }
            }
          }}
        />
      )}
      sx={{
        width: '100%',
        '& .MuiAutocomplete-input': {
          padding: '0 14px !important'
        },
        '& .MuiAutocomplete-endAdornment': {
          top: 'calc(50% - 14px)',
          '& .MuiButtonBase-root': {
            color: '#666',
            '&:hover': {
              color: '#1F1B45',
              backgroundColor: 'rgba(0, 0, 0, 0.04)',
            }
          }
        },
        '& .MuiAutocomplete-popupIndicator': {
          transform: 'none',
          '&.MuiAutocomplete-popupIndicatorOpen': {
            transform: 'rotate(180deg)',
          }
        }
      }}
    />
  );
};

